export default __webpack_public_path__ + "static/media/citation-print.75420ede.svg";